import { render, staticRenderFns } from "./PTAddressEmail.vue?vue&type=template&id=0f5fe808"
import script from "./PTAddressEmail.vue?vue&type=script&lang=js"
export * from "./PTAddressEmail.vue?vue&type=script&lang=js"
import style0 from "./PTAddressEmail.vue?vue&type=style&index=0&id=0f5fe808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports